import {css} from 'aphrodite';
import React from 'react';

import {DATE_TO_DISPLAY_WITH_LANGUAGE_TAG} from 'i18n/LanguageTagConstants';
import {ControlledLanguagePickerInput} from 'i18n/LanguageTags';
import LocalizationHelpBlock from 'i18n/LocalizationHelpBlock';
import {count} from 'metrics/Metrics';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';

import {automationFileConfigStyles, SectionNumber} from '../AutomationFileConfigUtils';
import {ClientAutomationOutputFileConfigSpec} from '../RunSchemaSpecConstants';

interface AutomationOutputFileConfigEditorLocalizationSectionProps {
  onUpdateConfig: (newConfig: ClientAutomationOutputFileConfigSpec) => void;
  outputFileConfig: ClientAutomationOutputFileConfigSpec;
  /** Controls whether this is the last section in the list and if so, does not add a border */
  isLastSection?: boolean;
}

export function AutomationOutputFileConfigEditorLocalizationSection(
  props: AutomationOutputFileConfigEditorLocalizationSectionProps
): JSX.Element {
  const labelText = 'Data locale';
  const outerClassName = props.isLastSection
    ? css(automationFileConfigStyles.subsection)
    : css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder);
  return (
    <div className={outerClassName}>
      <SectionNumber sectionNumber={6} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure {labelText.toLowerCase()}</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        <LocalizationHelpBlock includeIgnoreIfExcelText={true} />
      </div>
      <div className={css(automationFileConfigStyles.formatSectionContents)}>
        <div className={css(automationFileConfigStyles.formatSectionItem)}>
          <FieldLabel label={labelText} labelStyle={LabelStyle.LABEL} />
          <br />
          <ControlledLanguagePickerInput
            languageTag={props.outputFileConfig.spreadsheetProcessingLocale}
            date={new Date(DATE_TO_DISPLAY_WITH_LANGUAGE_TAG)}
            onSelect={(languageTag) => {
              count('bnch.localization.spreadsheet_locale_updated_count');
              props.onUpdateConfig({
                ...props.outputFileConfig,
                spreadsheetProcessingLocale: languageTag,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}
